import { createApiV2 } from "./common";

export const getProductsFromSalesOrder =
  ({ customerUid, orderUid } = {}) =>
  (token) =>
    createApiV2("GET", `customers/${customerUid}/orders/${orderUid}/purchase_products/`)(token);

export const postCreatePurchaseOrderFromSalesOrder =
  ({ customerUid, orderUid, payload } = {}) =>
  (token) =>
    createApiV2("POST", `customers/${customerUid}/orders/${orderUid}/purchase_products/`)(
      token,
      payload
    );
